import { Heart } from "lucide-react";

const TelcaBadge = () => {
  return (
    <a
      href="https://telcavoip.ai"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-2 left-2 z-[9998] flex items-center gap-1.5 bg-white/70 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-sm border border-gray-200/50 hover:bg-white hover:shadow-md transition-all opacity-60 hover:opacity-100"
      data-testid="telca-badge"
    >
      <Heart className="text-red-400 fill-red-400" size={10} />
      <span className="text-xs text-gray-500">
        TelcaVoIP AI
      </span>
    </a>
  );
};

export default TelcaBadge;
